module.exports = __webpack_public_path__ + "it-ePp.svg";